import styled from "styled-components";

export const CardContainer = styled.div`
  background: #323232;
  padding: 1.25rem;
  border-radius: 0.625rem;
  margin: 0.625rem;
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-basis: 0;
  box-sizing: border-box;

  @media (max-width: 1440px) {
    padding: 1rem;
  }

  @media (max-width: 1200px) {
    padding: 0.75rem;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    justify-content: center;
    width: 95%;
    padding: 0.75rem;
    align-items: flex-start;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  overflow-wrap: break-word;
  flex-shrink: 1;
`;

export const CardTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  color: #f0f1f5;
  word-wrap: break-word;
  flex-shrink: 1;

  @media (max-width: 1440px) {
    font-size: 1.25rem;
  }

  @media (max-width: 1200px) {
    font-size: 1.1rem;
  }

  @media (max-width: 900px) {
    font-size: 1rem;
  }
`;

export const CardValue = styled.p`
  font-size: 1.25rem;
  margin: 0.3125rem 0;
  color: var(--text-secondary);
  word-wrap: break-word;
  flex-shrink: 1;

  @media (max-width: 1440px) {
    font-size: 1rem;
  }

  @media (max-width: 1200px) {
    font-size: 0.875rem;
  }

  @media (max-width: 900px) {
    font-size: 0.75rem;
  }
`;

export const CardIconWrapper = styled.div`
  font-size: 3.5rem;
  margin-right: 1.25rem; 
  background: var(--bkg-tertiary);
  padding: 1.25rem; 
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--main-color);
  flex-shrink: 0; 

  @media (max-width: 1440px) {
    font-size: 2.5rem;
    padding: 1rem;
    margin-right: 1rem;
  }

  @media (max-width: 1200px) {
    font-size: 2rem;
    padding: 0.75rem;
    margin-right: 0.75rem;
  }

  @media (max-width: 900px) {
    font-size: 2rem;
    margin-right: 0;
    margin-bottom: 0.9375rem; 
`;

export const CardsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 1.25rem;
  box-sizing: border-box;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;
